// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610081616/js/" + chunkId + "." + {"44":"858f99be","225":"bfaafbd1","481":"c85b595d","486":"40f04f00","770":"0b3f270a"}[chunkId] + ".0.9857122893758912.chunk.js";
};